<template>
  <div class="d-flex flex-nowrap">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn small v-on="on" icon @click="firstPage" :disabled="value === 1">
          <v-icon>first_page</v-icon>
        </v-btn>
      </template>
      <span class="ma-1">
        {{ generateMessage('boilerplate.first_page') }}
      </span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          small
          v-on="on"
          icon
          @click="previousPage"
          :disabled="value === 1"
        >
          <v-icon>chevron_left</v-icon>
        </v-btn>
      </template>
      <span class="ma-1">
        {{ generateMessage('boilerplate.previous_page') }}
      </span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn small :disabled="disableNext" v-on="on" icon @click="nextPage">
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </template>
      <span class="ma-1">
        {{ generateMessage('boilerplate.next_page') }}
      </span>
    </v-tooltip>
  </div>
</template>

<script>
import { generateMessage } from '@/utils/i18n';

export default {
  name: 'custom-pagination',
  props: {
    value: {
      type: Number,
      required: true,
    },
    disableNext: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    nextPage() {
      this.$emit('input', this.value + 1);
    },
    previousPage() {
      if (this.value > 1) this.$emit('input', this.value - 1);
    },
    firstPage() {
      this.$emit('input', 1);
    },
    generateMessage,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
